import React, {useCallback, useEffect, useState} from "react";
import {IconButton, InputAdornment, TextField, Tooltip} from "@mui/material";
import PropTypes from "prop-types";
import {Box} from "@mui/system";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleXmark, faSearch} from "@fortawesome/pro-solid-svg-icons";
import {debounce} from "lodash";



/**
 * SearchTextField component renders a text field with search and clear functionality.
 *
 * @param {string} searchString - The current search string.
 * @param {function} setSearchString - Function to update the search string.
 * @param {string} [placeholder="Search"] - Placeholder text for the search field.
 * @param {object} [sx] - Optional styling object for the text field.
 * @param {boolean} [disabled=false] - Flag to disable the text field.
 */
const SearchTextField = ({ searchString, setSearchString, placeholder = "Search", sx, disabled = false, slotProps }) => {

	const [localSearchString, setLocalSearchString] = useState(searchString);

	const handleClear = () => {
		setLocalSearchString("");
		setSearchString("");
	};

	const debouncedSetSearchString = useCallback(
		debounce((value) => setSearchString(value), 500), []
	);

	useEffect(() => {
		debouncedSetSearchString(localSearchString);
		return () => {
			debouncedSetSearchString.cancel();
		};
	}, [localSearchString, debouncedSetSearchString]);
	// const test = {...sx};
	// console.log("SearchTextField", test);
	return (
		<Box
			id={"SearchFieldRoot"}
			sx={{
				// display: "flex",
				// minWidth: "265px",
				// height: "26px",
				// bgcolor: "white",
				...sx
			}}
		>
			<TextField
				size={"small"}
				sx={{ ...slotProps?.input?.sx }}
				fullWidth
				placeholder={placeholder}
				type="text"
				autoComplete="off"
				value={localSearchString}
				onChange={(event) => setLocalSearchString(event.target.value)}
				disabled={disabled}
				autoFocus={true}
				slotProps={{
					input: {
						startAdornment: (
							<InputAdornment size="small" position="start" sx={{color: "text.secondary", marginRight: 1}}>
								<FontAwesomeIcon icon={faSearch} />
							</InputAdornment>
						),
						endAdornment: searchString.length > 0 && (
							<Tooltip title="Reset search field">
								<IconButton size="small" onClick={() => handleClear()} sx={{color: "text.secondary", margin: 0}}>
									<FontAwesomeIcon icon={faCircleXmark} size={"xs"}/>
								</IconButton>
							</Tooltip>
						)
					}
				}}
			/>
		</Box>
	);
};
SearchTextField.propTypes = {
	searchString: PropTypes.string.isRequired,
	setSearchString: PropTypes.func.isRequired,
	handleClear: PropTypes.func,
	placeholder: PropTypes.string
};
export default SearchTextField;
